// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__fZVj6","container":"styles_container__zDbqB","main":"styles_main__7SyCG"};